export class ScPortalRequestIncome{
  incomeSourceName:string;
  scIncomeId:number;
    monthlyIncomeAmount:number;
    portalUserId :number;
    rowStatus:string;
    id:number;
}